/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  EMPTY_XERO_SYNC_PROGRESS,
  SystemVarsAccountsTwilioDto,
  SystemVarsAccountsXeroDto,
  SystemVarsAccountsXeroOauth1Dto,
  SystemVarsAccountsXeroSyncDto,
  SystemVarsAccountsXeroUrlDto,
  XeroSyncProgressDto,
} from '@gh/builder-shared-data';
import { mergeWithPrivelegedTokens } from '@gh/core-data';

export type SystemVarsAccountsTwilio = SystemVarsAccountsTwilioDto;
export type WithXeroSyncProgress<T> = T & {
  progress: SystemVarsAccountsXeroSyncProgress;
};
export type SystemVarsAccountsXeroOauth1 = WithXeroSyncProgress<SystemVarsAccountsXeroOauth1Dto>;
export type SystemVarsAccountsXero = WithXeroSyncProgress<SystemVarsAccountsXeroDto>;
export type SystemVarsAccountsXeroSyncProgress = XeroSyncProgressDto;
export type SystemVarsAccountsXeroUrl = SystemVarsAccountsXeroUrlDto;
export type SystemVarsAccountsXeroSync = SystemVarsAccountsXeroSyncDto;

export function systemVarsAccountsXeroToDto(model: SystemVarsAccountsXero): SystemVarsAccountsXeroDto {
  return <SystemVarsAccountsXeroDto>{
    ...model,
    etag: model.etag,
    privilegedTokens: mergeWithPrivelegedTokens(model),
  };
}

export const getXeroSyncProgress = (settings: SystemVarsAccountsXeroOauth1) => settings.progress || EMPTY_XERO_SYNC_PROGRESS;

export const isXeroSyncInProgress = (progress: SystemVarsAccountsXeroSyncProgress) =>
  progress.initialSyncInProgress || progress.syncInProgress;
